import React from 'react';
import get from 'lodash/get';

export const VideoField = ({ record, source }) => {
  const value = get(record, source);
  if (!value) {
    return null;
  }
  return (
    <div>
      <br />
      <strong>Video</strong>
      <br />
      <iframe
        title={`video-${source}`}
        src={`https://player.vimeo.com/video/${value}`}
        width="640"
        height="360"
        frameBorder="0"
        allow="autoplay; fullscreen"
        allowFullScreen
      />
    </div>
  );
};
VideoField.defaultProps = {
  addField: true,
};
